import * as tslib_1 from "tslib";
import { Actions, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { toPayload } from '../../core/helpers/rx-pipes';
import { StockService } from '../services/stock-service';
import * as stock from '../actions/stock.actions';
var StockEffects = /** @class */ (function () {
    function StockEffects(actions$, stockSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.stockSvc = stockSvc;
        this.getStock$ = this.actions$.ofType(stock.GET)
            .pipe(toPayload(), switchMap(function (codes) {
            return _this.stockSvc.getStock(codes)
                .pipe(map(function (result) { return new stock.GetSuccess(result); }), catchError(function (e) { return of(new stock.GetFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], StockEffects.prototype, "getStock$", void 0);
    return StockEffects;
}());
export { StockEffects };
